"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateValidateAllCarInfoRequestStatus = exports.updateReportPolicyData = exports.updateMostRecentCarPolicy = exports.updateCarPolicyForMotor = exports.updateCarPolicyForVin = exports.updateCarPolicyForLicense = exports.updatePoliciesForMotorRequestStatus = exports.updatePoliciesForVinRequestStatus = exports.updatePoliciesForLicenseRequestStatus = exports.overwriteCarPolicies = exports.initialState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.initialState = {
    policiesForLicenseRequestStatus: 'initial',
    policiesForVinRequestStatus: 'initial',
    policiesForMotorRequestStatus: 'initial',
    validateAllCarInfoRequestStatus: 'initial',
    carPolicyForLicense: undefined,
    carPolicyForVin: undefined,
    carPolicyForMotor: undefined,
    mostRecentCarPolicy: undefined,
    reportFoundPolicyData: false,
};
/**
 * There are some cases where the service we are using can't find a valid value for either
 * serialBody or serialMotor, and it will return either an empty string or the `null` value, depending
 * on whether the response was generated by us or by an external provider. To unify how responses are
 * treated, all "falsy" values will be converted to empty strings, so the data can be used by external
 * dependencies without taking into account all the possible falsy values.
 *
 * @param source - The car policy provided by the service
 */
function ensureNoNullValues(source) {
    if (!source) {
        return source;
    }
    return __assign(__assign({}, source), { plateNumber: source.plateNumber || '', serialBody: source.serialBody || '', serialMotor: source.serialMotor || '' });
}
var policiesSlice = toolkit_1.createSlice({
    name: 'policies',
    initialState: exports.initialState,
    reducers: {
        overwriteCarPolicies: function (_, action) {
            return action.payload;
        },
        updatePoliciesForLicenseRequestStatus: function (state, action) {
            state.policiesForLicenseRequestStatus = action.payload;
        },
        updatePoliciesForVinRequestStatus: function (state, action) {
            state.policiesForVinRequestStatus = action.payload;
        },
        updatePoliciesForMotorRequestStatus: function (state, action) {
            state.policiesForMotorRequestStatus = action.payload;
        },
        updateValidateAllCarInfoRequestStatus: function (state, action) {
            state.validateAllCarInfoRequestStatus = action.payload;
        },
        updateCarPolicyForLicense: function (state, action) {
            state.carPolicyForLicense = ensureNoNullValues(action.payload);
        },
        updateCarPolicyForVin: function (state, action) {
            state.carPolicyForVin = ensureNoNullValues(action.payload);
        },
        updateCarPolicyForMotor: function (state, action) {
            state.carPolicyForMotor = ensureNoNullValues(action.payload);
        },
        updateMostRecentCarPolicy: function (state, action) {
            state.mostRecentCarPolicy = ensureNoNullValues(action.payload);
        },
        updateReportPolicyData: function (state, action) {
            state.reportFoundPolicyData = action.payload;
        },
    },
});
exports.overwriteCarPolicies = (_a = policiesSlice.actions, _a.overwriteCarPolicies), exports.updatePoliciesForLicenseRequestStatus = _a.updatePoliciesForLicenseRequestStatus, exports.updatePoliciesForVinRequestStatus = _a.updatePoliciesForVinRequestStatus, exports.updatePoliciesForMotorRequestStatus = _a.updatePoliciesForMotorRequestStatus, exports.updateCarPolicyForLicense = _a.updateCarPolicyForLicense, exports.updateCarPolicyForVin = _a.updateCarPolicyForVin, exports.updateCarPolicyForMotor = _a.updateCarPolicyForMotor, exports.updateMostRecentCarPolicy = _a.updateMostRecentCarPolicy, exports.updateReportPolicyData = _a.updateReportPolicyData, exports.updateValidateAllCarInfoRequestStatus = _a.updateValidateAllCarInfoRequestStatus;
exports.default = policiesSlice.reducer;
//# sourceMappingURL=carPoliciesSlice.js.map